import React from "react";
import { inject, observer } from "mobx-react";
import { withRouter } from "react-router-dom";
import Cookies from "js-cookie";
import Metrika from "Services/Metrika";
import { YANDEX_TARGETS } from "Constants/metriks/yandex-targets";
import { EVENT_CATEGORY_CHOOSE_REGION } from "Constants/metriks/GoogleCategorys";
import querystring from "query-string";
import SwitchCityLayoutContainer from "Containers/SwitchCityLayoutContainer";
import { generateUrl } from "Services/withDefaultParams";
import configRouters from "Configs/routes";
import { Helmet } from "react-helmet-async";
import { isMainSiteCode } from "Utils/siteConfig";

@withRouter
@inject("ApplicationModel")
@observer
export default class SelectRegion extends React.Component {
	canonical() {
		const {
			ApplicationModel: { siteConfig },
		} = this.props;

		let location = generateUrl(configRouters.SelectRegion.route, this.props.match.params);

		return (
			<Helmet>
				<link
					rel="canonical"
					href={`${siteConfig.ssl === true ? `https` : "http"}://${
						siteConfig.domain_name_full
					}${location}`}
				/>
				<title>Выбор региона</title>
				<meta name="description" content={"Выбор региона"} />
			</Helmet>
		);
	}

	onItemSelect(item) {
		let {
			ApplicationModel: {
				regionConfirmationModel,
				siteConfig,
				searcheModelOneString,
				searcheModel,
			},
		} = this.props;

		const one_string_search = siteConfig?.settings?.one_string_search?.enabled;

		const searchModel = one_string_search ? searcheModelOneString : searcheModel;

		Metrika.getInstance().yandex.sendEvent(YANDEX_TARGETS.USER_SELECT_REGION, []);

		//Удаление информации о выбранном доме
		searchModel.setHouseId(0);
		Cookies.remove("house_id");

		this.setRegion(item);
		regionConfirmationModel.toggle();
		Cookies.set("isViewDetectRegion", "false");
	}
	constructor(props) {
		super(props);
		this.state = {
			searcheValue: "",
		};
	}

	findChangeHandler = (e) => {
		if (e) {
			let regex = /[*+?()[\]\\]/g;
			let value = e.target.value.replace(regex, "");
			this.setState({
				...this.state,
				searcheValue: value,
			});
		} else {
			this.setState({
				...this.state,
				searcheValue: "",
			});
		}
	};

	setRegion(region) {
		let {
			ApplicationModel: {
				detectRegionModel,
				commonViewModel,
				compareTarifficationsModel,
				searcheModel,
				searcheModelOneString,
				filtersModel,
			},
		} = this.props;
		commonViewModel.unblocking();
		compareTarifficationsModel.closeCompare();

		detectRegionModel.setAccept(region);
		this.props.ApplicationModel.setRegion(region);
		searcheModel.resetData();
		searcheModelOneString.resetData();

		filtersModel.reset();
		Metrika.getInstance().google.sendEvent(
			EVENT_CATEGORY_CHOOSE_REGION,
			!!region ? `choose_region.${region.name}` : "choose_region."
		);
	}

	render() {
		const parsed = querystring.parse(this.props.location?.search);
		const siteCode = this.props.ApplicationModel.siteCode;
		return (
			<>
				{this.canonical()}
				{isMainSiteCode(siteCode) && <div></div>}
				<SwitchCityLayoutContainer
					onItemSelect={(item) => this.onItemSelect(item)}
					searcheValue={this.state.searcheValue}
					findChangeHandler={this.findChangeHandler}
					blockedPath={!!parsed.backUrl ? parsed.backUrl : "/"}
					siteCode={this.props.ApplicationModel.siteCode}
					windowSizes={this.props.ApplicationModel.windowSizeModel.windowSizes}
				/>
			</>
		);
	}
}
